import type { PropsWithChildren } from 'react';

import Loader from 'components/technical/Loader/Loader';
import { FlagProvider, useFlagsStatus } from '@unleash/proxy-client-react';
import { getEnvType } from 'envConfig';
import { useAuth } from 'components/management/NewAuthProvider';

export function UnleashProvider({ children }: PropsWithChildren) {
  const env = getEnvType();
  const { user, isAdmin } = useAuth();
  const clientKey =
    env === 'prod'
      ? 'default:production.320e9406c1ea2474d168f4fae8832a2906affd103d0c33654cf9429d'
      : 'default:development.e6799b2886ed7863fff5e49e64b5cb1661d638aead73131e408b3984';

  return (
    <FlagProvider
      config={{
        url: 'https://unleash-api.team.genieai.tech/api/frontend',
        clientKey,
        appName: 'pms-v1',
        refreshInterval: 30,
        context: {
          userId: user?.cognitoUsername,
          properties: {
            role: isAdmin ? 'admin' : 'user',
          },
        },
      }}
    >
      <UnleashContent>{children}</UnleashContent>
    </FlagProvider>
  );
}

function UnleashContent(props: PropsWithChildren) {
  const { flagsReady } = useFlagsStatus();
  if (!flagsReady) {
    return <Loader />;
  }
  return props.children;
}
